import Drawer from "../../../../drawer/Drawer";
import ManageTransaction from "../ManageTransaction";

const ManageTransactionDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update Transaction" : "Add Transaction"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyclassName="p-0 max-h-[calc(100%-42px)]"
    >
      <ManageTransaction getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageTransactionDrawer;
